import './top.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import find from 'lodash/find';
import classname from 'classname';
import { baseUrl } from '../../../../config/route-entry-point';
import { formatMoney } from '../../../../modules/shared/format';
import { getCurrencyIcon } from '../../../../../shared/js/get-currency-icon';
import ManagerPopup from '../../../../modules/tickets/manager-popup/main';
import Avatar from '../../../../modules/shared/avatar';
import { actions, selectors } from '../../../../modules/tickets/manager-popup';
import pubDefaultAva from '../../assets/img/global/default-avatars/web_80x80.png';

const EXCLUDED_LANGUAGES = ['ru', 'en'];

const Main = (props) => {
	const {
		userData,
		lists,
		router,
		intl,
		logout,
		user,
		manager,
		refetchAll,
		saveInLocalStorage,
		loginWithAdmin
	} = props;
	const { general, balances, activeBalance } = userData;
	const defaultBalance = balances && find(balances, b => b.currency === activeBalance) || balances[0];
	const userId = general.id;
	const balancesList = getBalancesList(
		userId,
		balances,
		activeBalance,
		saveInLocalStorage,
		intl
	);
	const showAddCurrency = balances.length < lists['available-currencies'].length;
	const handleLogout = (e) => {
		e.preventDefault();
		logout();
		refetchAll();
	};

	const showBetaLangTicketLink = !EXCLUDED_LANGUAGES.includes(general.language);
	const isVisiblePoints = userData.contestConfig && !!userData.contestConfig.isVisiblePoints;

	return (
		<div className="header-top">

			{showBetaLangTicketLink && (
				<div className="beta-lang">
					<div className="container">
						<Link
							className="beta-lang-link font-proxima-nova-regular"
							to={`tickets/request/improve_translation`}>
							{intl('Бета версия перевода, сообщайте баги в тикеты')}
						</Link>
					</div>
				</div>
			)}

			<header className="container">

				<a href='' onClick={handleLogout} className="logout">
					<span className="hover-bg" />
				</a>
				<Link to={baseUrl('profile/')} className="user" activeClassName='active'>
					<span className="user__wrap">
						<Avatar className="user__avatar"  src={general.avatar || pubDefaultAva} />
						<div className="user__info">
							<div className="user__info__nickname">
								{general.nickname && general.nickname.length ? general.nickname : general.email}
							</div>
							<div className="user__info__id">ID: {userId}</div>
						</div>
					</span>
				</Link>
				<div
					className={cn({ 'your-manager-short': true, 'hidden': general.level === 'registered' })}
				>
					<div
						className="your-manager-short__tab"
					>
						<Avatar className="user__avatar" src={manager.avatar || pubDefaultAva} />
						<div className="your-manager font-proxima-nova-regular">
							<p className="manager-title">{intl('Ваш менеджер:')}</p>
							<p className="manager-name">{manager.name}</p>
						</div>
					</div>
					<ManagerPopup
						intl={intl}
						data={manager}
						user={user}
						fetchManager={props.fetchManager}
					/>
				</div>

				{ defaultBalance ? (
					<div className="balance dropdown">
						<div className="dropdown__head">
							<span className="balance-title">
								<span>{ intl('Ваш') }</span>
								<span>{ intl('баланс') }</span>
							</span>
							<span className="balance-amount font-proxima-nova-regular">
								{ !defaultBalance.is_hidden_on_navbar && formatMoney(defaultBalance.amount, true) }
								<span className="currency"> { getCurrencyIcon(defaultBalance.currency) }</span>
							</span>

						</div>
						<div className="dropdown_suggests">
							{ balancesList }
							{showAddCurrency && (
								<div className="dropdown_suggests-item clearfix add_currency_item">
									<div className="dropdown_suggests-item_group amount-group">
										<Link className="add_currency" to={baseUrl('profile/')}>
											{ intl('Добавить валюту')}<span className="icon-plus"/>
										</Link>
									</div>
								</div>
							)}
						</div>
					</div>
				) : (
					<Link to={baseUrl('profile/')} className="no-balance">
						<span className="no-balance__wrap">
							<span className="no-balance__text">{ intl('Добавить валюту')}</span>
						</span>
					</Link>
				)}
				{
					isVisiblePoints &&
						<div className="balance points">
							<div>
								<span className="balance-title">
									<span>{ intl('Твои') }</span>
									<span>{ intl('Ever-ы') }</span>
								</span>
								<span className="balance-amount points font-proxima-nova-regular">
									{ general.contest_points }
								</span>
							</div>
						</div>
				}
				{ !userData['general']['is_from_admin'] ? (
					<div className={cn({
						'main-logo_container': true
					})}>
						<span className="logo container__left">
							<span className="font-proxima-nova-bold">
								{
									router.pathname.indexOf('dashboard') === -1
										? <Link to={ baseUrl() }>Everad</Link>
										: <span>Everad</span>
								}
							</span>
							{ router.pathname.indexOf('dashboard') === -1 &&
								<Link className="back-to-dashboard" to={ baseUrl() }>{ intl('Дашборд') }</Link>
							}
						</span>
					</div>
				) : (
					<div className="admin-logout container__left">
						<a
							className="admin-logout-link"
							onClick={e => {
								e.preventDefault();
								loginWithAdmin();
							}}>
							<p className="font-proxima-nova-regular">
								<span>{ intl(general['source_page']['title']) }</span>
							</p>
						</a>
						<span className="dashboard-link">
							{ router.pathname.indexOf('dashboard') === -1 &&
							<Link className="back-to-dashboard" to={ baseUrl() }>{ intl('Дашборд') }</Link>
							}
						</span>
					</div>
				) }

			</header>
		</div>
	);
};

const getBalancesList = (
	userId,
	balances,
	activeBalance,
	saveInLocalStorage,
	intl
) => {
	return balances.map(balance => {
		const { currency, hold_amount, amount } = balance;
		const className = classname({
			'dropdown_suggests-item': true,
			'clearfix': true,
			'active': currency == activeBalance
		});

		if (balance.is_hidden_on_navbar) {
			return null;
		}

		if (currency === 'rub' && !Number(hold_amount) && !Number(amount))
			return null;

		return (
			<div key={currency} className={className} onClick={e => {
				saveInLocalStorage('activeBalance', JSON.stringify({userId, currency: balance.currency}));
				const list = document.body.querySelector('.dropdown_suggests');
				list.style.display = 'none';
				setTimeout(() => {list.style.display = 'block';}, 500);
			}}>
				<div className="left-part">
					<div className="dropdown_suggests-item_group amount-group">
						<div className="dropdown_suggests-item_key">
							<span className="currency">{ `${intl('Баланс')} ${intl(`${currency}_s`)}` }</span>
						</div>
						<div className="dropdown_suggests-item_value balance_value">
							{ !balance.is_hidden_on_navbar && formatMoney(balance.amount, true) }
						</div>
					</div>
					<div className="dropdown_suggests-item_group">
						<div className="dropdown_suggests-item_key">{ intl('На холде') }</div>
						<div className="dropdown_suggests-item_value hold_value">
							{ !balance.is_hidden_on_navbar && formatMoney(balance.hold_amount, true) }
						</div>
					</div>
				</div>
				<div className="currency-icon">{ getCurrencyIcon(currency) }</div>
			</div>
		);
	});
};

Main.propTypes = {
	userData: PropTypes.object,
	manager: PropTypes.object,
	lists: PropTypes.object,
	router: PropTypes.object,
	intl: PropTypes.func,
	logout: PropTypes.func,
	refetchAll: PropTypes.func,
	saveInLocalStorage: PropTypes.func,
	loginWithAdmin: PropTypes.func
};

export default connect(
	state => ({
		userData: state.app.userData,
		lists: state.app.lists,
		user:  selectors.getUser(state),
		router: state.routing.locationBeforeTransitions,
		manager: selectors.getManager(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/header/top.js